import React from "react";
import "./HeadCard.css"
import { Button } from 'react-bootstrap';
import { FaRegLightbulb } from 'react-icons/fa';
import Taux from "../../assets/images/taux.png"
import Interet from '../../assets/images/interet.png'
import Envoyer from '../../assets/images/envoyer.png'
import netpay from '../../assets/images/netpay.jpg'
import netsub from "../../assets/images/netsub.jpg"
import netw from '../../assets/images/netw.jpg'
import { Fade } from "react-awesome-reveal";
import 'animate.css';
const HeadCard =  () =>{
    return(
        <div className="container HeadCard ">
          <div className="d-flex flex-column flex-md-row headIN justify-content-center align-content-center">
            <div className="d-flex flex coulumn m-0 align-items-center col-md-4">
                <img 
                    src={netw}
                    alt=""
                    style={{width:'6rem'}}
                  />
                <div className="d-flex flex-column align-items-center order-1">
                  <h3 className="h3 h3-md-up">Netikash Pay</h3>
                </div>
            </div>
            <div className="vertical-divider col-md-1"></div>
            <div className="d-flex flex coulumn m-3 align-items-center col-md-4">
                  <img 
                    src={netsub}
                    alt=""
                    className="m-2"
                    style={{width:'5rem'}}
                  />
                  <div className="d-flex flex-column align-items-center order-md-1">
                    <h3 className="h3 h3-md-up">Netikash Subscribe </h3>
                  </div>
            </div>
            <div className="vertical-divider col-md-1"></div>
            <div className="d-flex flex coulumn m-3 align-items-center col-md-4">
                <img 
                    src={netpay}
                    alt=""
                    style={{width:'6rem'}}
                  />
                  <div className="d-flex flex-column align-items-center order-md-1">
                   <h3 className="h3 h3-md-up">Netikash Payme </h3>
                  </div>
            </div>
          </div>
        </div>
    )
};

export default HeadCard;